import { useContext } from "react";
import { CCProcessorConfigurationContext } from "helpers/online_ordering/payments/CCProcessorConfigurationContext";

export const useCCProcessorConfiguration = () => {
  return useContext(CCProcessorConfigurationContext);
};
